

const state = {
  token: localStorage.getItem('token') || '',
  user : JSON.parse(localStorage.getItem('user')) || [],
  userRole: localStorage.getItem('userRole') || '',
  windowWidth: null,
  ViewAsCustomer:null,
  adminUser:null,
  licenseAgreed: localStorage.getItem('licenseAgreed') || false,
}

export default state